import React from "react";
import { Modal } from "react-bootstrap";

const CustomModal = (props) => {
  const { show, children, centered = false, size = "m" } = props;

  return (
    <Modal
      className={`${!centered && "custom-modal-container"}`}
      centered={centered}
      show={show}
      size={size}
    >
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default CustomModal;
